import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';

const sliderContainers = document.querySelectorAll('.slider-sections');

sliderContainers.forEach((container) => {
  const backgroundSlider = container.querySelector('.slider-sections__background');
  const contentSlider = container.querySelector('.slider-sections__content');
  const overlaySlider = container.querySelector('.slider-sections__overlay');


  const createLoopSlides = (sliderElement) => {
    const wrapper = sliderElement.querySelector('.swiper-wrapper');
    const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

    const firstClone = slides[0].cloneNode(true);
    firstClone.classList.add('swiper-slide-duplicate');
    wrapper.appendChild(firstClone);

    const lastClone = slides[slides.length - 1].cloneNode(true);
    lastClone.classList.add('swiper-slide-duplicate');
    wrapper.insertBefore(lastClone, slides[0]);

    return slides.length;
  };

  const totalSlides = createLoopSlides(contentSlider);
  createLoopSlides(backgroundSlider);
  if (overlaySlider) {
    createLoopSlides(overlaySlider);
  }

  const swiperBackground = new Swiper(backgroundSlider, {
    modules: [EffectFade],
    effect: 'fade',
    allowTouchMove: true,
    watchSlidesProgress: true,
    initialSlide: 1,
    resistanceRatio: 0,
    speed: 1200,
  });

  let swiperOverlay = null;
  if (overlaySlider) {
    swiperOverlay = new Swiper(overlaySlider, {
      speed: 600,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
      allowTouchMove: false,
      initialSlide: 1,
      resistanceRatio: 0,
    });
  }

  const swiperContent = new Swiper(contentSlider, {
    modules: [Autoplay],
    speed: 800,
    allowTouchMove: true,
    initialSlide: 1,
    resistanceRatio: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
  });

  let isAnimating = false;
  let isLooping = false;
  let isSyncing = false;
  let loopTimeout = null;

  const buttons = container.querySelectorAll('.wp-block-buttons');

  const hideButtons = () => {
    buttons.forEach(btn => {
      btn.classList.remove('visible');
    });
  };

  const revealButtons = () => {
    buttons.forEach(btn => {
      btn.classList.add('visible');
    });
  };

  swiperContent.on('slideChangeTransitionStart', hideButtons);
  swiperContent.on('slideChangeTransitionEnd', revealButtons);

  swiperContent.on('slideChangeTransitionStart', () => {
    isAnimating = true;
  });

  swiperContent.on('slideChangeTransitionEnd', () => {
    setTimeout(() => {
      if (!isLooping) {
        isAnimating = false;
      }
    }, 100);
  });

  swiperBackground.on('slideChangeTransitionStart', () => {
    isAnimating = true;
  });

  swiperBackground.on('slideChangeTransitionEnd', () => {
    setTimeout(() => {
      if (!isLooping) {
        isAnimating = false;
      }
    }, 100);
  });

  if (swiperOverlay) {
    swiperOverlay.on('slideChangeTransitionStart', () => {
      isAnimating = true;
    });

    swiperOverlay.on('slideChangeTransitionEnd', () => {
      setTimeout(() => {
        if (!isLooping) {
          isAnimating = false;
        }
      }, 100);
    });
  }

  const isDesktop = () => window.innerWidth >= 1024;

  backgroundSlider.addEventListener('click', (e) => {
    if (!isDesktop() || isAnimating || isLooping) return;

    const rect = backgroundSlider.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const sliderWidth = rect.width;
    const clickPosition = clickX / sliderWidth;

    if (clickPosition < 0.5) {
      swiperContent.slidePrev();
    } else {
      swiperContent.slideNext();
    }
  });


  if (isDesktop()) {
    backgroundSlider.style.cursor = 'pointer';

    backgroundSlider.addEventListener('mousemove', (e) => {
      const rect = backgroundSlider.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const sliderWidth = rect.width;
      const mousePosition = mouseX / sliderWidth;


    });

    backgroundSlider.addEventListener('mouseleave', () => {
      backgroundSlider.style.cursor = 'pointer';
    });
  }

  const handleLoopJump = (targetIndex) => {
    if (isLooping) return;

    isLooping = true;

    if (loopTimeout) {
      clearTimeout(loopTimeout);
    }

    loopTimeout = setTimeout(() => {
      isSyncing = true;
      swiperContent.slideTo(targetIndex, 0);
      swiperBackground.slideTo(targetIndex, 0);
      if (swiperOverlay) {
        swiperOverlay.slideTo(targetIndex, 0);
      }

      setTimeout(() => {
        isLooping = false;
        isAnimating = false;
        isSyncing = false;
      }, 100);
    }, 1250);
  };

  swiperContent.on('slideChangeTransitionEnd', () => {
    const index = swiperContent.activeIndex;

    if (index === 0) {
      handleLoopJump(totalSlides);
    }
    else if (index === totalSlides + 1) {
      handleLoopJump(1);
    }
  });

  swiperContent.on('slideChange', () => {
    if (isLooping || isSyncing) return;

    if (isAnimating && !isSyncing) {
      return;
    }

    isSyncing = true;
    const index = swiperContent.activeIndex;
    swiperBackground.slideTo(index, 1200);
    if (swiperOverlay) {
      swiperOverlay.slideTo(index, 600);
    }

    setTimeout(() => {
      isSyncing = false;
    }, 1250);
  });

  swiperBackground.on('slideChangeTransitionEnd', () => {
    const index = swiperBackground.activeIndex;

    if (index === 0) {
      handleLoopJump(totalSlides);
    }
    else if (index === totalSlides + 1) {
      handleLoopJump(1);
    }
  });

  swiperBackground.on('slideChange', () => {
    if (isLooping || isSyncing) return;

    if (isAnimating && !isSyncing) {
      return;
    }

    isSyncing = true;
    const index = swiperBackground.activeIndex;
    swiperContent.slideTo(index, 800);
    if (swiperOverlay) {
      swiperOverlay.slideTo(index, 600);
    }

    setTimeout(() => {
      isSyncing = false;
    }, 1250);
  });

  if (swiperOverlay) {
    swiperOverlay.on('slideChangeTransitionEnd', () => {
      const index = swiperOverlay.activeIndex;

      if (index === 0) {
        handleLoopJump(totalSlides);
      }
      else if (index === totalSlides + 1) {
        handleLoopJump(1);
      }
    });
  }
});
